<template>
  <div class="coupon">
      <div class="coupon-con">
            <tr class="coupon-head">
              <td class="coupon-name">
                  <p class="coupon-type">{{couponData.title}}</p>
                  <p v-if="couponData.category==0" class="coupon-useable-type font-12">适用范围:{{couponRangeStr(couponData)}}</p>
                  <p v-if="couponData.category==0" class="color-red">满{{couponData.doorsill}}元可用</p>
                  <p v-if="couponData.category==1" class="color-red">优惠券编号:{{couponData.no}}</p>
                  <p v-if="couponData.category==1" class="color-red">兑换码:{{couponData.code}}</p>
              </td>
              <td class="coupon-amount">
                  <div v-if="couponData.category==0"  class="coupon-amount-value">
                      <p v-if="couponData.type!=1" class="font-22 color-red" >{{couponData.faceValue0}}元</p>
                      <p v-if="couponData.type==1" class="font-22 color-red" >{{couponData.faceValue0}}折</p>
                      <p v-if="couponData.category==0" class="font-12">{{couponType(couponData.type)}}</p>
                  </div>
                  <div v-if="couponData.category==1" class="coupon-amount-value">
                      <p v-if="couponData.type!=11" class="font-22 color-red" >{{couponData.faceValue1}}元</p>
                      <p v-if="couponData.type==11" class="font-22 color-red" >{{couponData.faceValue1}}</p>
                  </div>
                  
              </td>
            </tr>
            <tr class="coupon-body">
              <td class="coupon-valid">有效期至:{{couponData.end}}</td>
              <td class="coupon-condition" @click="showRemark">查看说明</td>
            </tr>
            <div v-if="couponData.status==2" class="coupon-status-tag">已使用</div>
            <div v-if="couponData.status==3" class="coupon-status-tag">已过期</div>
        </div>
        <van-popup v-model="remarkShow" class="coupon-remark">
            <p class="coupon-remark-title">优惠券说明</p>
            <p v-for="item in remarkList" :key="item.index">{{item}}</p>
        </van-popup>
  </div>
</template>

<script>

  export default {
    name: "appeal",
    props:{
        couponData:{}
    },
    data() {
        return {
          remarkShow:false,
          remarkList:[],
        }

      },
      methods: {
          showRemark(){
              this.remarkShow=true;
          },
          //优惠券类型转字符串
          couponType(type){
            var typeStr="";
            switch(type){
                case 0:
                    typeStr="代金券"
                    break;
                case 1:
                    typeStr="折扣券"
                    break;
                case 10:
                    typeStr="平台核销券"
                    break;
                case 11:
                    typeStr="商家实体券"
                    break; 
            }
            return typeStr;
          },
          //优惠券适用范围拼接
          couponRangeStr(couponData){
              var couponRangeStr="";
              if(couponData.roadParkingRange==1){
                  couponRangeStr+="路内停车."
              }
              if(couponData.parkParkingRange==1){
                  couponRangeStr+="场库停车."
              }
              if(couponData.roadEscapeRange==1){
                  couponRangeStr+="路内停车逃费补缴."
              }
              if(couponData.parkSubscribeStatus==1){
                  couponRangeStr+="场库预约停车."
              }
              if(couponData.parkOnlineCardStatus==1){
                  couponRangeStr+="场库线上月卡."
              }
              if(couponData.roadOnlineCardStatus==1){ 
               couponRangeStr+="路内线上月卡."
              }
              if(couponData.walletRechargeStatus==1){ 
               couponRangeStr+="充值."
              }
              return couponRangeStr;
          },
          //优惠券说明文字切割
          transformRemarkList(){
              let remarkStr=this.couponData.remark;
              this.remarkList=remarkStr.split("。");
              //console.log(this.remarkList);
          }
      },
      created() {
          this.transformRemarkList();
      },
      mounted() {},
  };
</script>

<style scoped>
.coupon-con{
    width: 98%;
    height: 160px;
    margin-left: 1%;
    border-radius: 8px;
    background-color: #FFF;
    margin-top: 8px;
    position: relative;
    /* float: left; */
}
.coupon-con tr{
    display: inline-block;
}
.coupon-head{
    height: 120px;
    width: 100%;
    border-bottom: 1px rgb(153, 26, 26) dashed;
    /* float: left; */
}
.coupon-body{
    height: 40px;
    width: 98%;
    float: left;   
}
.coupon-amount{
    width: 23%;
    height: 100px;
    display: inline-block;
    text-align: center;
    line-height: 90px;
    font-weight: bold;
    vertical-align: top;
}
.coupon-amount-value{
    height: 60px;
    margin-top: 15px;
}
.coupon-name{
    width: 75%;
    height: 120px;
    line-height: 60px;
    display: inline-block;
    color: #000;
    vertical-align: top;
    text-align: left;
    font-size: 14px;
}
.coupon-name p,.coupon-amount p{
    margin: 0;
    padding: 0;
    height: 30px;
    line-height: 30px;
    padding-left: 12px;
}
.coupon-useable-type{
    height: 60px !important;
    line-height: 20px !important;
}
.coupon-type{
    font-size: 18px;
    font-weight: bold;
}
.coupon-choose{
    width: 15%;
    height: 60px;
    display: inline-block;
    line-height: 60px;
    vertical-align: top;
    text-align: center;
}
.coupon-valid{
    width: 65%;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    display: inline-block;
    text-align: left;
    vertical-align: top;
    padding-left: 12px;
}
.coupon-condition{
    width: 25%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    display: inline-block;  
    vertical-align: top;
    font-size: 14px;

}

.color-red{
    color: rgb(235, 27, 27);
}
.font-12{
    font-size: 12px;
}
.font-22{
    font-size: 22px;
}
.coupon-status-tag{
    height: 70px;
    width: 70px;
    line-height: 70px;
    background-color: rgba(229, 229, 229, 0.7);
    display: inline-block;
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
    border: 1px #000 dashed;
    color: red;
    z-index: 999;
    position: absolute;
    top: 10px;
    right: 10px;
}
.coupon-remark{
    height: 300px;
    width: 70%;
    border-radius: 8px;
}
.coupon-remark p{
    margin: 0;
    padding: 0 12px;
}
.coupon-remark-title{
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/coupon/components/coupon.vue